import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import {
  loadAboutPage,
  loadContactPage,
  loadAwardsPage,
  loadPress,
  loadSocial,
  loadSolar,
  loadWater,
  loadITAutomation,
  loadEVCharging,
  loadBrandingAdvertising,
  loadFilmProduction,
  loadRaahiPage,
} from "./lazyRoutes";

// Every route other than Home is code-split: its chunk is only fetched once the
// homepage has finished loading (see prefetchOtherRoutes in Home.js), so the very
// first paint only depends on the homepage's own code.
const AboutPage = lazy(loadAboutPage);
const ContactPage = lazy(loadContactPage);
const AwardsPage = lazy(loadAwardsPage);
const Press = lazy(loadPress);
const Social = lazy(loadSocial);
const Solar = lazy(loadSolar);
const Water = lazy(loadWater);
const ITAutomation = lazy(loadITAutomation);
const EVCharging = lazy(loadEVCharging);
const BrandingAdvertising = lazy(loadBrandingAdvertising);
const FilmProduction = lazy(loadFilmProduction);
const RaahiPage = lazy(loadRaahiPage);

function App() {
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/press" element={<Press />} />
          <Route path="/awards" element={<AwardsPage />} />
          <Route path="/social" element={<Social />} />
          <Route path="/solar" element={<Solar />} />
          <Route path="/ev" element={<EVCharging />} />
          <Route path="/film" element={<FilmProduction />} />
          <Route path="/branding" element={<BrandingAdvertising />} />
          <Route path="/water" element={<Water />} />
          <Route path="/it" element={<ITAutomation />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/raahi" element={<RaahiPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
